document.addEventListener('DOMContentLoaded', () => {
  var accordionTriggers = document.getElementsByClassName('nfb-accordion-item__trigger');

  for (var i = 0; i < accordionTriggers.length; i++) {
      accordionTriggers[i].onclick = function() {
          var content = this.parentElement.querySelector('.nfb-accordion-item__content');
          console.log(content.offsetHeight, content.scrollHeight)
          if (content.offsetHeight === 0) {
              this.parentElement.classList.add('open');
              content.style.height = content.scrollHeight + "px";
          } else {
              this.parentElement.classList.remove('open');
              content.style.height = 0;
          }
      }
  } 
})
